import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  static readonly items$ = new BehaviorSubject<Array<any>>([]);

  constructor() { }

  static download(blobParts: BlobPart[], fileTitle: string, options: BlobPropertyBag = { type: 'blob' }) {
    FileDownloadService.items$.next([
      ...FileDownloadService.items$.value,
      {
        url: URL.createObjectURL(new Blob(blobParts, options)),
        fileTitle,
      }
    ]);
  }

  static generateUrl(blobParts: BlobPart[], options: BlobPropertyBag = { type: 'blob' }): string {
    return URL.createObjectURL(new Blob(blobParts, options));
  }

  static openContentInNewWindow(content: string): Window | null {
    const windowInstance = window.open();
    if (windowInstance) {
      windowInstance.document.body.innerHTML = content;
    }
    return windowInstance;
  }

  static async parseJsonFromBlobStream<T = any>(blobStream: Blob): Promise<T> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = function () {
        try {
          resolve(JSON.parse(fr.result as string) as T);
        } catch (e) {
          reject(e);
        }
      };
      fr.onerror = () => reject(fr.error);
      fr.readAsText(blobStream);
    });
  }
}
